<template>
  <ul v-if="salesclerkModule === 1" class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
    <li class="nav-item">
      <router-link :to="indexLink" class="nav-link text-white" active-class="active">Ventas</router-link>
    </li>
    <v-guard :permissions="['PRESUPUESTOS']">
      <li class="nav-item">
        <router-link :to="presupuestosLink" class="nav-link text-white" active-class="active">Presupuestos</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="notasDePedidoLink" class="nav-link text-white" active-class="active">Notas de pedido</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="remitosDeVentaLink" class="nav-link text-white" active-class="active">Remitos</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="combosLink" class="nav-link text-white" active-class="active">Combos</router-link>
    </li>
    <v-guard :permissions="['CLIENTES']">
      <li class="nav-item">
        <router-link :to="clientesLink" class="nav-link text-white" active-class="active">Clientes</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="vendedoresLink" class="nav-link text-white" active-class="active">Vendedores</router-link>
    </li>
    <v-guard :permissions="['CLIENTES_CTA_CORRIENTE']">
      <li class="nav-item">
        <router-link :to="ccClientesLink" class="nav-link text-white" active-class="active">Cuenta corriente de clientes</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="cobranzasLink" class="nav-link text-white" active-class="active">Cobranzas</router-link>
      </li>
    </v-guard>
    <BranchofficeSelect v-if="hasPermission" />
  </ul>
  <ul v-else class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
    <li class="nav-item">
      <router-link :to="indexLink" class="nav-link text-white" active-class="active">Ventas</router-link>
    </li>
    <v-guard :permissions="['PRESUPUESTOS']">
      <li class="nav-item">
        <router-link :to="presupuestosLink" class="nav-link text-white" active-class="active">Presupuestos</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="notasDePedidoLink" class="nav-link text-white" active-class="active">Notas de pedido</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="remitosDeVentaLink" class="nav-link text-white" active-class="active">Remitos</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="combosLink" class="nav-link text-white" active-class="active">Combos</router-link>
    </li>
    <v-guard :permissions="['CLIENTES']">
      <li class="nav-item">
        <router-link :to="clientesLink" class="nav-link text-white" active-class="active">Clientes</router-link>
      </li>
    </v-guard>
    <v-guard :permissions="['CLIENTES_CTA_CORRIENTE']">
      <li class="nav-item">
        <router-link :to="ccClientesLink" class="nav-link text-white" active-class="active">Cuenta corriente de clientes</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="cobranzasLink" class="nav-link text-white" active-class="active">Cobranzas</router-link>
      </li>
    </v-guard>
    <BranchofficeSelect v-if="hasPermission" />
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BranchofficeSelect from "./../sub-components/branchoffice-select.vue";
  export default {
    components: {
        BranchofficeSelect
    },
    data() {
      return {
        hasPermission: false
      }
    },
    methods: {
      getAllBranchofficesPermission() {
        this.$http
          .get("/api/configs/role/permissions/names", {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            },
          })
          .then((response) => {
            this.hasPermission = response.data.data.includes('ACCESS_ALL_BRANCHOFFICES_SALES');
          })
      },
    },
    computed: {
      ...mapGetters({
        authUser: 'authUser/getUser'
      }),
      // Se lee del store (lo carga MainNavbar) en vez de pedir /api/users/getAuthUser de nuevo.
      salesclerkModule() {
        const bo = this.authUser && this.authUser.branchoffices && this.authUser.branchoffices[0];
        return bo && bo.options ? bo.options.salesclerk_module : 0;
      },
      indexLink() {
        return { name: 'Ventas' }
      },
      presupuestosLink() {
        return { name: 'Presupuestos' }
      },
      notasDePedidoLink() {
        return { name: 'Notas de pedido' }
      },
      remitosDeVentaLink() {
        return { name: 'Remitos de venta' }
      },
      combosLink() {
        return { name: 'Combos' }
      },
      clientesLink() {
        return { name: 'Clientes' }
      },
      vendedoresLink() {
        return { name: 'Vendedores' }
      },
      ccClientesLink() {
        return { name: 'Cuenta corriente de clientes' }
      },
      cobranzasLink() {
        return { name: 'Cobranzas' }
      },
      //nuevaVentaLink() {
      //  return { name: 'Nueva venta' }
      // },
    },
    mounted() {
      this.getAllBranchofficesPermission();
    },
  }
</script>

<style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #264775;
  /* justify-content-start fijo (no solo mientras carga el selector de
     sucursal) para que no haya salto de layout al montar/desmontar. */
  padding-left: 1rem;
}

.lasubnav .nav-link {
  padding: 11px;
  color: white;
  font-weight: bold;
}

.lasubnav .nav-link:not(.active) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.lasubnav .nav-link:hover,
.lasubnav .nav-link:focus {
  color: white;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: #4477bd;
  border-radius: 4px;
}
</style>
